import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {CellRuleWrapper} from './cellRuleWrapper';
import {CellSummaryWrapper} from './cellSummaryWrapper';

interface CellRuleNotifyProps {
  isSelected?: boolean;
}

export const CellRuleNotify: FC<CellRuleNotifyProps> = (props) => (
  <CellRuleWrapper isSelected={props.isSelected}>
    <CellSummaryWrapper {...props}>
      <Trans id="cell-bottom-line-notify-rule">You were notified by a rule.</Trans>
    </CellSummaryWrapper>
  </CellRuleWrapper>
);
